import type * as React from 'react'

import type { RichTextEditor } from '@disco/shared-components/rich-text-editor'

export type DraftContent = NonNullable<
  React.ComponentProps<typeof RichTextEditor>['initialContent']
>

export type EditorKind = 'edit' | 'reply'
const MAX_DRAFTS = 50

const drafts = new Map<string, DraftContent>()
const openEditors = new Set<string>()

const openKey = (kind: EditorKind, id: number | string): string =>
  `${kind}:${id}`

export const getDraft = (key: string): DraftContent | null =>
  drafts.get(key) ?? null

export const setDraft = (key: string, content: DraftContent): void => {
  if (!drafts.has(key) && drafts.size >= MAX_DRAFTS) {
    const oldest = drafts.keys().next().value
    if (oldest !== undefined) drafts.delete(oldest)
  }
  drafts.set(key, content)
}

export const clearDraft = (key: string): void => {
  drafts.delete(key)
}

export const isEditorOpen = (kind: EditorKind, id: number | string): boolean =>
  openEditors.has(openKey(kind, id))

export const setEditorOpen = (
  kind: EditorKind,
  id: number | string,
  open: boolean,
): void => {
  const key = openKey(kind, id)
  if (open) {
    openEditors.add(key)
  } else {
    openEditors.delete(key)
  }
}
